import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import type {
  DocumentPickerListQuery,
  DocumentPickerListQueryVariables,
} from '#graphql/generated';

/** id + path only — for @note “apply edits” when the thread has no document context. */
export const DOCUMENT_PICKER_LIST: TypedDocumentNode<
  DocumentPickerListQuery,
  DocumentPickerListQueryVariables
> = gql`
  query DocumentPickerList($search: String) {
    documents(search: $search) {
      id
      path
    }
  }
`;
